import React from "react";
import aboutUs from "../../PicesForPages/FinancingOptionsSelfEmployed.jpg";
import FreeConsultation from "../Form/FreeConsultation";

function LoansForSelfEmployed() {
  return (
    <>
      <div className="purchaseParent">
        <div className="purchasetopParent">
          <img
            fetchPriority="high"
            loading="eager"
            src={aboutUs}
            alt="aboutUsImage"
            className="background-video aboutUsImage"
          />
          <div className="purchasetopBox">Loans for Self Employed</div>
        </div>
        {/* <div className="joinTheTeamFormParent"> */}
        <div className="purchaseBottomParent">
          <div className="purchaseBottomBox joinTheTeamBottomBox">
            <div className="purchaseBottomLeftBox">
              {/* <span className="purchaseBottomLeftHeader">
                What can FHA offer you?
              </span>
              <span className="purchaseBottomLeftSubHeader">
                First-time homebuyer?
              </span> */}
              {/* <div className="purchaseBottomLeftHeader">Conventional Loans</div> */}

              <span className="purchaseBottomLeftContent">
                For self-employed individuals and small business owners,
                traditional income documentation—like W-2s or tax returns—often
                fails to capture the true financial strength of their
                operations. Fortunately, alternative lending programs have
                emerged to fill this gap: Bank Statement Loans and Profit & Loss
                (P&L) Loans. Both are designed to evaluate your ability to repay
                a mortgage using non-traditional income documentation. Here’s an
                in-depth look at each option.
              </span>

              <hr />
              <span
                className="purchaseBottomLeftHeader"
                style={{ textAlign: "center" }}
              >
                Bank Statement Loans
              </span>

              <span className="purchaseBottomLeftSubHeader">Overview:</span>
              <span className="purchaseBottomLeftContent">
                Bank Statement Loans allow documentation of income through
                monthly bank statements instead of relying solely on tax
                returns. Lenders typically review a full year of business bank
                statements to assess your cash flow and confirm consistent
                deposits. This flexible documentation method offers
                self-employed borrowers an opportunity to qualify for a mortgage
                when conventional income verification falls short.
              </span>

              <span className="purchaseBottomLeftSubHeader">
                How They Work:
              </span>
              <ul className="purchaseBottomLeftUL paperworkBottomLeftUL">
                <li>
                  <b>Income Calculation:</b> Lenders evaluate 12 months of bank
                  statements, excluding non-business deposits. They often apply
                  a predetermined expense ratio to these deposits to arrive at a
                  net income figure.
                </li>
                <li>
                  <b>Expense Adjustments:</b> Some programs may allow
                  third-party CPA verification to adjust the expense ratio if
                  your actual business expenses are lower than the industry
                  standard.
                </li>
                <li>
                  <b>Benefits:</b> These loans tend to simplify the process by
                  prioritizing cash flow, thus enabling many self-employed
                  individuals to secure competitive financing
                </li>
              </ul>

              <span className="purchaseBottomLeftSubHeader">
                Key Considerations:
              </span>
              <ul className="purchaseBottomLeftUL paperworkBottomLeftUL">
                <li>
                  Applicants must provide a consistent record of deposits over a
                  specified period.
                </li>
                <li>
                  The underwriting process centers on cash flow without
                  scrutinizing traditional tax documents.
                </li>
              </ul>

              <hr />
              <span
                className="purchaseBottomLeftHeader"
                style={{ textAlign: "center" }}
              >
                Profit & Loss (P&L) Loans
              </span>

              <span className="purchaseBottomLeftSubHeader">Overview:</span>
              <span className="purchaseBottomLeftContent">
                P&L Loans utilize a borrower’s Profit & Loss statements to
                determine qualification. This method provides a more detailed
                breakdown of your business’s revenues, expenses, and overall
                profitability as reported by a licensed professional. It is
                particularly useful for borrowers whose taxable income does not
                accurately reflect their economic reality due to various
                deductions and write-offs.
              </span>

              <span className="purchaseBottomLeftSubHeader">
                How They Work:
              </span>
              <ul className="purchaseBottomLeftUL paperworkBottomLeftUL">
                <li>
                  <b>Income Verification:</b> Lenders require a certified P&L
                  statement, generally covering the last 12 months. This
                  document outlines gross revenue, operating expenses, and net
                  income.
                </li>
                <li>
                  <b>Comprehensive Financial Picture:</b> Unlike bank statement
                  loans, P&L loans offer an in-depth view of business
                  performance, capturing trends and seasonal variations that tax
                  returns might miss.
                </li>
                <li>
                  <b>Benefits:</b> This option can be ideal if you have
                  significant write-offs or deductions that lower your taxable
                  income but do not diminish your cash flow.
                </li>
              </ul>

              <span className="purchaseBottomLeftSubHeader">
                Key Considerations:
              </span>
              <ul className="purchaseBottomLeftUL paperworkBottomLeftUL">
                <li>
                  A licensed tax preparer or CPA must prepare or verify the P&L
                  statements.
                </li>
                <li>
                  Since these loans place heavy emphasis on detailed financial
                  reporting, thorough documentation is essential.
                </li>
              </ul>

              <hr />
              <span
                className="purchaseBottomLeftHeader"
                // style={{ textAlign: "center" }}
              >
                Comparing the Two Options
              </span>
              <span className="purchaseBottomLeftContent">
                Both Bank Statement and P&L Loans provide alternative methods
                for calculating income, catering to the unique cash flow
                challenges faced by self-employed borrowers. While bank
                statement loans emphasize consistency in deposits and are
                generally simpler in their documentation requirements, P&L loans
                deliver a comprehensive overview of business profitability
                through a detailed financial report.
              </span>
              <span className="purchaseBottomLeftContent">
                Ultimately, the right choice depends on your individual
                business’s financial structure and which documentation method
                best represents your earning potential. Consulting with a
                mortgage specialist experienced in non-traditional income
                verification can help you determine which loan program aligns
                with your financial goals.
              </span>

              <i className="purchaseBottomLeftContent">
                Disclaimer: This blog is for informational purposes only and
                does not constitute legal, financial, or tax advice. Please
                consult with a professional for personalized guidance.
              </i>
            </div>
            <FreeConsultation />
          </div>
        </div>
      </div>
      {/* </div> */}
    </>
  );
}

export default LoansForSelfEmployed;
